import { TextArea } from "@/components/text-area/TextArea";
import { LightMode } from "@/components/ui/color-mode";
import { AppColors } from "@/styles/colors";
import {
  Button,
  CloseButton,
  Dialog,
  Flex,
  MenuOpenChangeDetails,
  Portal,
  Text,
} from "@chakra-ui/react";
import { FieldValues, UseFormRegister } from "react-hook-form";

interface Props {
  open: boolean;
  onOpenChange: (e: MenuOpenChangeDetails) => void;
  loading: boolean;
  errors: any;
  register: UseFormRegister<FieldValues>;
  value: string;
  onConfirm: () => void;
}

export const RequireChangesModal = ({
  open,
  onOpenChange,
  loading,
  errors,
  register,
  value,
  onConfirm,
}: Props) => {
  return (
    <Dialog.Root placement="center" lazyMount open={open} onOpenChange={onOpenChange}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <LightMode>
            <Dialog.Content width={{ base: "calc(100vw - 32px)", md: "720px" }} maxW="720px">
              <Dialog.Header paddingY="16px" paddingLeft="24px">
                <Dialog.Title
                  fontWeight={600}
                  color={AppColors.GRAY_TEXT}
                  fontSize="18px"
                >
                  Requerir cambios
                </Dialog.Title>
              </Dialog.Header>

              <Dialog.Body paddingX="24px" paddingY="8px" width="100%">
                <Flex flexDir="column" gap="10px">
                  <Text fontSize="16px" color={AppColors.GRAY_TEXT}>
                    Escribe el detalle de los cambios requeridos
                  </Text>
                  <TextArea
                    errors={errors}
                    inputName="require_changes_detail"
                    register={register}
                    placeholder="Ingresar detalle"
                    minHeight="240px"
                    resize="vertical"
                    required
                    disabled={loading}
                  />
                </Flex>
              </Dialog.Body>

              <Dialog.Footer paddingY="16px" paddingX="24px">
                <Dialog.ActionTrigger asChild>
                  <Button variant="outline" paddingX="16px" fontWeight={600}>
                    Cancelar
                  </Button>
                </Dialog.ActionTrigger>
                <Button
                  paddingX="16px"
                  bgColor={AppColors.GREEN_PRIMARY}
                  fontWeight={600}
                  onClick={onConfirm}
                  loading={loading}
                  disabled={loading || !value.trim().length}
                >
                  Aceptar
                </Button>
              </Dialog.Footer>

              <Dialog.CloseTrigger asChild>
                <CloseButton size="sm" />
              </Dialog.CloseTrigger>
            </Dialog.Content>
          </LightMode>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
